export const API_URL = process.env.REACT_APP_API_URL;

// 공통
export const COMMON_API_ROUTES = {
    // 게시판 --------------------
    BOARD_LIST: "/v1/board/:category/:limit",
    BOARD_DETAIL: "/v1/board/view/:category/:idx",
    BOARD_FILE_DOWNLOAD: "/v1/board/download/:category/:parent_idx/:idx",
};

// 사용자
export const USER_API_ROUTES = {
    // 팝업 --------------------
    POPUP_LIST: "/v1/auth/popup/",
    POPUP_DETAIL: "/v1/auth/popup/:idx",

    // 문의사항 --------------------
    CONTACT_FORM: "/v1/auth/form",

    // 인스타그램 --------------------
    INSTAGRAM_LIST: "/v1/instagram/list",
};

// 관리자
export const CONSOLE_API_ROUTES = {
    // 로그인 --------------------
    LOGIN: "/v1/auth/login",

    // 게시판 관리 --------------------
    BOARD_MANAGE: "/v1/board/",
    BOARD_NOTICE: "/v1/board/notice",
    BOARD_FILE: "/v1/board/file",
    BOARD_MOVE_ORDER: "/v1/board/moveOrder",

    // 팝업 관리 --------------------
    POPUP: "/v1/admin/popup",
    POPUP_STATE: "/v1/admin/popup/open",
    POPUP_DETAIL: "/v1/admin/popup/:idx",
};
